import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import Store from '@apricityhealth/web-common-lib/reduxStore';
import App from './App';

import './index.css';

const store = Store();

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter basename="/">
            <App />
        </BrowserRouter>,
    </Provider>,
    document.getElementById('root')
);
